/**
 * A grade de cobertura produto × projeto, e o recálculo da descrição.
 *
 * **O relatório equivalente do sistema antigo devolve grade vazia sempre.** Ele
 * procura o conteúdo por dois caminhos e os dois morreram: `dado_versao` tem 320
 * linhas e nenhuma com sistema; `dado_item` tem zero linhas com `modelo_id > 0`
 * entre as 34.017 cujo `dado` ainda existe. A tela não dá erro — mostra tudo "-"
 * e parece que falta conteúdo em toda parte.
 *
 * A API refez sobre `TabelaPesquisa`, o índice vivo: 144.008 linhas com modelo,
 * sistema, assunto, produto e base na mesma linha.
 */

import { api, foraDoProjeto, obter } from "./cliente"

export type ModeloDaCobertura = { modeloId: number; modelo: string; veiculo: string; motor: string }
export type SistemaDaCobertura = { sistemaId: number; sistema: string }
export type CelulaDaCobertura = { modeloId: number; sistemaId: number; dadoId: number; dado: string }

export type Cobertura = {
  projetoId: number
  projeto: string
  produtoId: number
  produto: string
  assuntoId: number
  assunto: string
  baseId: number
  porPinoutGrafico: boolean
  modelos: number
  sistemas: number
  celulas: number
  preenchidas: number
  avisos: string[]
  linhas: ModeloDaCobertura[]
  colunas: SistemaDaCobertura[]
  conteudos: CelulaDaCobertura[]
}

export function obterCobertura(p: {
  projetoId: number
  produtoId: number
  assuntoId: number
  sistemaIds: number[]
  baseId: number
}) {
  return obter<Cobertura>("api/cobertura/produto-projeto", p)
}

// ------------------------------------------------------------------ descrição

export type DescricaoRecalculada = {
  dadoId: number
  baseId: number
  atual: string
  proposta: string
}

export type RecalculoDeDescricao = {
  produtoId: number
  produto: string
  baseId: number | null
  aplicado: boolean
  conteudos: number
  vaoMudar: number
  jaEstaoAssim: number
  ficariamVazios: number
  alterados: number
  perderiamTexto: number
  avisos: string[]
  mudancas: DescricaoRecalculada[]
}

/**
 * **Confere por padrão.** O "aplicar" do sistema antigo grava o id no lugar da
 * descrição, por um `cont == 1` repetido onde devia ser `cont == 3`. E mesmo
 * feito certo, a regra empobrece: no produto 26, 1.008 dos 1.026 mudariam e 410
 * ficariam mais curtos, perdendo ano e acabamento.
 */
export async function recalcularDescricao(p: {
  produtoId: number
  baseId?: number | null
  aplicar: boolean
}) {
  const q = new URLSearchParams({ produtoId: String(p.produtoId), aplicar: String(p.aplicar) })
  if (p.baseId) q.set("baseId", String(p.baseId))

  const r = await api.post<RecalculoDeDescricao>(
    `api/cobertura/descricao-recalculada?${q}`, null, foraDoProjeto(),
  )
  return r.data
}
